/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint ignore:start */
import React, { useContext, useEffect, useRef, useState } from "react";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { RxCross2 } from "react-icons/rx";
import { MyContext } from "../Context/MyProvider";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { showTost } from "../showTost";
import LodingLottie from "../Lodinglottie";

const Favorites = () => {

  const { t } = useTranslation();

  const { basUrl, imageBaseURL } = useContext(MyContext);
  const naviget = useNavigate();

  const [showPage, setShowPage] = useState();
  const [favourite, setFavourite] = useState([]);
  const [newMatch, setNewMatch] = useState([]);
  const [likeMe, setLikeMe] = useState([]);
  const [passed, setPassed] = useState([]);
  const [userCoords, setUserCoords] = useState({ lat: null, long: null });
  const [isShow, setIsShow] = useState(true);
  const [loading, setLoading] = useState(false);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentIndex2, setCurrentIndex2] = useState(0);
  const [currentIndex3, setCurrentIndex3] = useState(0);
  const [currentIndex4, setCurrentIndex4] = useState(0);

  const [totalCards, setTotalCards] = useState(0);
  const [totalCards2, setTotalCards2] = useState(0);
  const [totalCards3, setTotalCards3] = useState(0);
  const [totalCards4, setTotalCards4] = useState(0);

  const fetchedRef = useRef(false);

  const ShowPageHandler = (el) => {
    sessionStorage.setItem("Explore", el);
    setShowPage(el);
  };

  useEffect(() => {
    if (fetchedRef.current) return;

    fetchedRef.current = true;

    if (sessionStorage.getItem("Explore")) {
      setShowPage(sessionStorage.getItem("Explore"));
    } else {
      setShowPage("Match");
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setUserCoords({ lat: pos.coords.latitude, long: pos.coords.longitude });
      },
      (err) => console.warn("Location error:", err),
      { enableHighAccuracy: true }
    );

  }, []);

  useEffect(() => {
    if (!userCoords.lat || !userCoords.long) return;
    NewMatchHandler(userCoords.lat, userCoords.long);
    LikeMeHandler(userCoords.lat, userCoords.long);
    FavouritrHandler(userCoords.lat, userCoords.long);
    PassedHandler(userCoords.lat, userCoords.long);
  }, [userCoords]);

  const fetchData = async (url, params, setCards, setTotalCards, currentIndex) => {
    try {

      setLoading(true);

      const localData = localStorage.getItem("Register_User");
      const userData = JSON.parse(localData);

      const [response] = await Promise.all([
        await axios.post(url, {
          uid: userData.id,
          lats: params.lat,
          longs: params.long
        }),
      ]);

      if (response.data.Result === "true") {
        const dataList = response.data[params.listName];

        if (currentIndex === 0) {
          setCards(dataList.slice(0, 12));
        } else {
          setCards(prevCards => [
            ...prevCards,
            ...dataList.slice(currentIndex, currentIndex + 12)
          ]);
        }
        setTotalCards(dataList.length);
        setIsShow(false);
      }
    } catch (error) {
      console.error(`Error fetching ${params.listName}:`, error);
    } finally {
      setLoading(false);
    }
  };

  const NewMatchHandler = (lat, long) => {
    fetchData(`${basUrl}new_match.php`, { lat, long, listName: "profilelist" }, setNewMatch, setTotalCards, currentIndex, setCurrentIndex);
  };

  const FavouritrHandler = (lat, long) => {
    fetchData(`${basUrl}favourite.php`, { lat, long, listName: "favlist" }, setFavourite, setTotalCards2, currentIndex2, setCurrentIndex2);
  };

  const LikeMeHandler = (lat, long) => {
    fetchData(`${basUrl}like_me.php`, { lat, long, listName: "likemelist" }, setLikeMe, setTotalCards3, currentIndex3, setCurrentIndex3);
  };

  const PassedHandler = (lat, long) => {
    fetchData(`${basUrl}passed.php`, { lat, long, listName: "passedlist" }, setPassed, setTotalCards4, currentIndex4, setCurrentIndex4);
  };

  useEffect(() => {
    if (showPage === "Match") NewMatchHandler(userCoords.lat, userCoords.long);
  }, [currentIndex]);

  useEffect(() => {
    if (showPage === "Favorite") FavouritrHandler(userCoords.lat, userCoords.long);
  }, [currentIndex2]);

  useEffect(() => {
    if (showPage === "Like") LikeMeHandler(userCoords.lat, userCoords.long);
  }, [currentIndex3]);

  useEffect(() => {
    if (showPage === "Passed") PassedHandler(userCoords.lat, userCoords.long);
  }, [currentIndex4]);

  const handleScroll = () => {

    if (loading) return;

    const ScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const ScrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
    const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
    const clientHeight2 = window.innerHeight;

    if (window.innerWidth < 430) {
      var isAtBottom = ScrollTop + clientHeight2 >= ScrollHeight - 100;
    } else {
      var isAtBottom = ScrollTop + clientHeight >= ScrollHeight - 1;
    }
    if (isAtBottom) {
      if (showPage === "Match" && newMatch.length < totalCards) {
        setCurrentIndex(prevIndex => prevIndex + 12);
      } else if (showPage === "Favorite" && favourite.length < totalCards2) {
        setCurrentIndex2(prevIndex => prevIndex + 12);
      } else if (showPage === "Like" && likeMe.length < totalCards3) {
        setCurrentIndex3(prevIndex => prevIndex + 12);
      } else if (showPage === "Passed" && passed.length < totalCards4) {
        setCurrentIndex4(prevIndex => prevIndex + 12);
      }
    }
  };

  useEffect(() => {
    const handleTouchMove = (e) => {
      console.log("Touchmove triggered");
      handleScroll();
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("touchmove", handleTouchMove);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("touchmove", handleTouchMove);
    };
  }, [handleScroll]);


  const DetailsHandler = (profile_id, name) => {
    const Title = name.replace(/\s+/g, '_');
    const FinalText = Title.toLowerCase();
    naviget(`/detail/${FinalText}`, { state: { ProfileId: profile_id } });
  };

  const UserLikeHandler = (Id) => {
    const localData = localStorage.getItem("Register_User");
    const userData = JSON.parse(localData);

    axios.post(`${basUrl}like_dislike.php`, { uid: userData.id, profile_id: Id, action: "LIKE" })
      .then((res) => {
        showTost({ title: res.data.ResponseMsg });
        LikeMeHandler(userCoords.lat, userCoords.long);
        FavouritrHandler(userCoords.lat, userCoords.long);
      });
  };

  const UserUnLikeHandler = (Id) => {
    const localData = localStorage.getItem("Register_User");
    const userData = JSON.parse(localData);

    axios.post(`${basUrl}like_dislike.php`, { uid: userData.id, profile_id: Id, action: "UNLIKE" })
      .then((res) => {
        showTost({ title: res.data.ResponseMsg });
        LikeMeHandler(userCoords.lat, userCoords.long);
        PassedHandler(userCoords.lat, userCoords.long);
      });
  };

  return (
    <div className="bg-[#e5e5e5] main-wrapper-history">
      <div className="content-body">
        <div className="container-fluid py-4 px-sm-4 px-3">
          <div className="row">
            <div className="col-xl-12 max-_1030_:sticky top-[70px] max-_1030_:z-[555] bg-[#e5e5e5] ">
              <div className="card card-rounded my-[20px] max-_430_:my-3">
                <div className="py-[20px] px-[20px] max-_430_:py-[10px] max-_430_:px-[0px] scroll-container2 mx-[10px]">
                  <div className="flex items-center gap-[20px] w-[100%]">
                    <button
                      onClick={() => ShowPageHandler("Match")}
                      style={{
                        color: showPage === "Match" ? "white" : "rgba(152,14,255,255)",
                        background: showPage === "Match"
                          ? "rgba(152,14,255,255)"
                          : "#970eff31",
                      }}
                      className="inline-block p-[15px] max-_430_:p-[10px] rounded-[30px]"
                    >
                      <div className="flex justify-around whitespace-nowrap items-center gap-[6px] ">
                        <svg width="25" height="25" viewBox="0 0 40 41" fill="" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M26.4154 4.7698C27.4671 4.7698 28.5171 4.91813 29.5154 5.25313C35.6671 7.25313 37.8837 14.0031 36.0321 19.9031C34.9821 22.9181 33.2654 25.6698 31.0171 27.9181C27.7987 31.0348 24.2671 33.8015 20.4654 36.1848L20.0487 36.4365L19.6154 36.1681C15.8004 33.8015 12.2487 31.0348 9.00039 27.9015C6.76706 25.6531 5.04873 22.9181 3.98206 19.9031C2.09873 14.0031 4.31539 7.25313 10.5337 5.21813C11.0171 5.05146 11.5154 4.9348 12.0154 4.8698H12.2154C12.6837 4.80146 13.1487 4.7698 13.6154 4.7698H13.7987C14.8487 4.80146 15.8654 4.9848 16.8504 5.3198H16.9487C17.0154 5.35146 17.0654 5.38646 17.0987 5.41813C17.4671 5.53646 17.8154 5.6698 18.1487 5.85313L18.7821 6.13646C18.9351 6.21808 19.1069 6.3428 19.2553 6.45058C19.3494 6.51887 19.4341 6.58037 19.4987 6.6198C19.5259 6.63585 19.5536 6.65198 19.5814 6.66825C19.7243 6.75167 19.8732 6.83857 19.9987 6.9348C21.8504 5.5198 24.0987 4.75313 26.4154 4.7698ZM30.8487 16.7698C31.5321 16.7515 32.1154 16.2031 32.1654 15.5015V15.3031C32.2154 12.9681 30.8004 10.8531 28.6487 10.0365C27.9654 9.80146 27.2154 10.1698 26.9654 10.8698C26.7321 11.5698 27.0987 12.3365 27.7987 12.5848C28.8671 12.9848 29.5821 14.0365 29.5821 15.2015V15.2531C29.5504 15.6348 29.6654 16.0031 29.8987 16.2865C30.1321 16.5698 30.4821 16.7348 30.8487 16.7698Z"
                            fill={showPage === "Match" ? "white" : "#970eff31"} stroke="rgba(152,14,255,255)" stroke-width="2" />
                        </svg>
                        <h6 className="m-0 inline-block text-[18px] font-[400] max-_430_:text-[16px]">
                          {t('New Match')}
                        </h6>
                      </div>
                    </button>

                    <button
                      onClick={() => ShowPageHandler("Like")}
                      style={{
                        color: showPage === "Like" ? "white" : "rgba(152,14,255,255)",
                        background: showPage === "Like"
                          ? "rgba(152,14,255,255)"
                          : "#970eff31",
                      }}
                      className="inline-block p-[15px] max-_430_:p-[10px] rounded-[30px]"
                    >
                      <div className="flex justify-around whitespace-nowrap items-center gap-[6px]">
                        <svg width="25" height="25" viewBox="0 0 40 41" fill="" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M26.4154 4.7698C27.4671 4.7698 28.5171 4.91813 29.5154 5.25313C35.6671 7.25313 37.8837 14.0031 36.0321 19.9031C34.9821 22.9181 33.2654 25.6698 31.0171 27.9181C27.7987 31.0348 24.2671 33.8015 20.4654 36.1848L20.0487 36.4365L19.6154 36.1681C15.8004 33.8015 12.2487 31.0348 9.00039 27.9015C6.76706 25.6531 5.04873 22.9181 3.98206 19.9031C2.09873 14.0031 4.31539 7.25313 10.5337 5.21813C11.0171 5.05146 11.5154 4.9348 12.0154 4.8698H12.2154C12.6837 4.80146 13.1487 4.7698 13.6154 4.7698H13.7987C14.8487 4.80146 15.8654 4.9848 16.8504 5.3198H16.9487C17.0154 5.35146 17.0654 5.38646 17.0987 5.41813C17.4671 5.53646 17.8154 5.6698 18.1487 5.85313L18.7821 6.13646C18.9351 6.21808 19.1069 6.3428 19.2553 6.45058C19.3494 6.51887 19.4341 6.58037 19.4987 6.6198C19.5259 6.63585 19.5536 6.65198 19.5814 6.66825C19.7243 6.75167 19.8732 6.83857 19.9987 6.9348C21.8504 5.5198 24.0987 4.75313 26.4154 4.7698ZM30.8487 16.7698C31.5321 16.7515 32.1154 16.2031 32.1654 15.5015V15.3031C32.2154 12.9681 30.8004 10.8531 28.6487 10.0365C27.9654 9.80146 27.2154 10.1698 26.9654 10.8698C26.7321 11.5698 27.0987 12.3365 27.7987 12.5848C28.8671 12.9848 29.5821 14.0365 29.5821 15.2015V15.2531C29.5504 15.6348 29.6654 16.0031 29.8987 16.2865C30.1321 16.5698 30.4821 16.7348 30.8487 16.7698Z"
                            fill={showPage === "Like" ? "white" : "#970eff31"} stroke="rgba(152,14,255,255)" stroke-width="2" />
                        </svg>
                        <h6 className="m-0 inline-block text-[18px] font-[400] max-_430_:text-[16px]">
                          {t('Like Me')}
                        </h6>
                      </div>
                    </button>

                    <button
                      onClick={() => ShowPageHandler("Favorite")}
                      style={{
                        color: showPage === "Favorite" ? "white" : "rgba(152,14,255,255)",
                        background: showPage === "Favorite"
                          ? "rgba(152,14,255,255)"
                          : "#970eff31",
                      }}
                      className="inline-block p-[15px] max-_430_:p-[10px] rounded-[30px]"
                    >
                      <div className="flex justify-around whitespace-nowrap items-center gap-[7px]">
                        <svg width="25" height="25" viewBox="0 0 40 41" fill="" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M26.4154 4.7698C27.4671 4.7698 28.5171 4.91813 29.5154 5.25313C35.6671 7.25313 37.8837 14.0031 36.0321 19.9031C34.9821 22.9181 33.2654 25.6698 31.0171 27.9181C27.7987 31.0348 24.2671 33.8015 20.4654 36.1848L20.0487 36.4365L19.6154 36.1681C15.8004 33.8015 12.2487 31.0348 9.00039 27.9015C6.76706 25.6531 5.04873 22.9181 3.98206 19.9031C2.09873 14.0031 4.31539 7.25313 10.5337 5.21813C11.0171 5.05146 11.5154 4.9348 12.0154 4.8698H12.2154C12.6837 4.80146 13.1487 4.7698 13.6154 4.7698H13.7987C14.8487 4.80146 15.8654 4.9848 16.8504 5.3198H16.9487C17.0154 5.35146 17.0654 5.38646 17.0987 5.41813C17.4671 5.53646 17.8154 5.6698 18.1487 5.85313L18.7821 6.13646C18.9351 6.21808 19.1069 6.3428 19.2553 6.45058C19.3494 6.51887 19.4341 6.58037 19.4987 6.6198C19.5259 6.63585 19.5536 6.65198 19.5814 6.66825C19.7243 6.75167 19.8732 6.83857 19.9987 6.9348C21.8504 5.5198 24.0987 4.75313 26.4154 4.7698ZM30.8487 16.7698C31.5321 16.7515 32.1154 16.2031 32.1654 15.5015V15.3031C32.2154 12.9681 30.8004 10.8531 28.6487 10.0365C27.9654 9.80146 27.2154 10.1698 26.9654 10.8698C26.7321 11.5698 27.0987 12.3365 27.7987 12.5848C28.8671 12.9848 29.5821 14.0365 29.5821 15.2015V15.2531C29.5504 15.6348 29.6654 16.0031 29.8987 16.2865C30.1321 16.5698 30.4821 16.7348 30.8487 16.7698Z"
                            fill={showPage === "Favorite" ? "white" : "#970eff31"} stroke="rgba(152,14,255,255)" stroke-width="2" />
                        </svg>
                        <h6 className="m-0 inline-block text-[18px] font-[400] max-_430_:text-[16px]">
                          {t('Favourite')}
                        </h6>
                      </div>
                    </button>

                    <button
                      onClick={() => ShowPageHandler("Passed")}
                      style={{
                        color: showPage === "Passed" ? "white" : "rgba(152,14,255,255)",
                        background: showPage === "Passed"
                          ? "rgba(152,14,255,255)"
                          : "#970eff31",
                      }}
                      className="inline-block p-[15px] max-_430_:p-[10px] rounded-[30px]"
                    >
                      <div className="flex justify-around whitespace-nowrap items-center gap-[7px]">
                        <svg width="25" height="25" viewBox="0 0 40 41" fill="" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M26.4154 4.7698C27.4671 4.7698 28.5171 4.91813 29.5154 5.25313C35.6671 7.25313 37.8837 14.0031 36.0321 19.9031C34.9821 22.9181 33.2654 25.6698 31.0171 27.9181C27.7987 31.0348 24.2671 33.8015 20.4654 36.1848L20.0487 36.4365L19.6154 36.1681C15.8004 33.8015 12.2487 31.0348 9.00039 27.9015C6.76706 25.6531 5.04873 22.9181 3.98206 19.9031C2.09873 14.0031 4.31539 7.25313 10.5337 5.21813C11.0171 5.05146 11.5154 4.9348 12.0154 4.8698H12.2154C12.6837 4.80146 13.1487 4.7698 13.6154 4.7698H13.7987C14.8487 4.80146 15.8654 4.9848 16.8504 5.3198H16.9487C17.0154 5.35146 17.0654 5.38646 17.0987 5.41813C17.4671 5.53646 17.8154 5.6698 18.1487 5.85313L18.7821 6.13646C18.9351 6.21808 19.1069 6.3428 19.2553 6.45058C19.3494 6.51887 19.4341 6.58037 19.4987 6.6198C19.5259 6.63585 19.5536 6.65198 19.5814 6.66825C19.7243 6.75167 19.8732 6.83857 19.9987 6.9348C21.8504 5.5198 24.0987 4.75313 26.4154 4.7698ZM30.8487 16.7698C31.5321 16.7515 32.1154 16.2031 32.1654 15.5015V15.3031C32.2154 12.9681 30.8004 10.8531 28.6487 10.0365C27.9654 9.80146 27.2154 10.1698 26.9654 10.8698C26.7321 11.5698 27.0987 12.3365 27.7987 12.5848C28.8671 12.9848 29.5821 14.0365 29.5821 15.2015V15.2531C29.5504 15.6348 29.6654 16.0031 29.8987 16.2865C30.1321 16.5698 30.4821 16.7348 30.8487 16.7698Z"
                            fill={showPage === "Passed" ? "white" : "#970eff31"} stroke="rgba(152,14,255,255)" stroke-width="2" />
                        </svg>
                        <h6 className="m-0 inline-block text-[18px] font-[400] max-_430_:text-[16px]">
                          {t('Passed')}
                        </h6>
                      </div>
                    </button>

                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-12 max-_430_:py-4">

              {showPage === "Match" && (
                newMatch.length > 0
                  ? <div className="grid grid-cols-4 grid-transition grid-responsive   card p-[16px] card-rounded">
                    {newMatch?.map((el, i) => {
                      return (
                        <div key={i} onClick={() => DetailsHandler(el.profile_id, el.profile_name)} className="custom-card cursor-pointer card-rounded-1 duration-[1s] ease-in z-[111]" >
                          <div className="position-relative ">
                            <div className="card-title rounded-1">
                              <div className="card-img relative HEIGHT">
                                <div className=" flex justify-center w-[100%] absolute">
                                  <h6 className="m-0 text-white font-[400] text-[14px] bg-[rgba(152,14,255,255)] p-2 rounded-b-[15px]">{el.match_ratio.toFixed(0)}% Match</h6>
                                </div>
                                <img src={imageBaseURL + el.profile_images[0]} alt="img" className="img-fluid rounded-[3rem] BEFORE border-[5px] border-[rgba(152,14,255,255)]" />
                              </div>
                              <div className="card-content absolute bottom-5 px-[10px] w-full">
                                <div className="profile-info">
                                  <div className="KM2 mb-2">
                                    <h6 className="m-0 ml-1 flex items-center gap-1"><HiOutlineLocationMarker /> {el.profile_distance}</h6>
                                  </div>
                                  <div className="text-center">
                                    <h6 className="font-semibold mb-1 text-white">
                                      {el.profile_name}, {el.profile_age}
                                    </h6>
                                  </div>
                                  <p className="bio mb-1 text-[18px] text-center mt-[5px] text-white overflow-ellipsis overflow-hidden whitespace-nowrap">
                                    {el.profile_bio !== "undefined" ? el.profile_bio : ""}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>)
                    })}
                  </div>
                  : <div className="p-[16px] bg-white h-[480px] rounded-[0.56rem] flex justify-center items-center">
                    <h2 className="m-0 text-center">{t('No Any Match Profiles...')}</h2>
                  </div>
              )}
              {showPage === "Like" && (
                likeMe.length > 0
                  ? <div className="grid grid-cols-4 grid-transition grid-responsive card p-[16px] card-rounded">
                    {likeMe.map((el, i) => {
                      return (
                        <div key={i} onClick={() => DetailsHandler(el.profile_id, el.profile_name)} className="custom-card cursor-pointer card-rounded-1 duration-[1s] ease-in z-[111]" >
                          <div className="position-relative ">
                            <div className="card-title">
                              <div className="card-img relative HEIGHT">
                                <div className=" flex justify-end pe-[45px] w-[100%] absolute">
                                  <h6 className="m-0 text-white font-[400] text-[14px] bg-[rgba(152,14,255,255)] p-2 rounded-b-[15px]">{el.match_ratio.toFixed(0)}% Match</h6>
                                </div>
                                <img src={imageBaseURL + el.profile_images[0]} alt="img" className="img-fluid rounded-[3rem] BEFORE border-[5px] border-[rgba(152,14,255,255)]  " />
                              </div>
                              <div className="card-content absolute bottom-[2rem] px-[20px] w-[100%]">
                                <div className="flex items-center max-_430_:justify-evenly justify-between">
                                  <div className="w-[65%]">
                                    <h6 className="fw-semi-bold mb-1 text-start text-white">{el.profile_name}, {el.profile_age}</h6>
                                    <p className="mb-1 text-[18px] text-start mt-[5px] text-white overflow-ellipsis overflow-hidden whitespace-nowrap">
                                      {el.profile_bio === "undefined" ? "" : el.profile_bio}
                                    </p>
                                  </div>
                                  <div className="flex gap-[10px]">
                                    <button onClick={(e) => { e.stopPropagation(); UserUnLikeHandler(el.profile_id); }}>
                                      <RxCross2 className="w-[50px] h-[50px] p-[9px] rounded-full text-white bg-[#fdfdfd52]" />
                                    </button>
                                    <button onClick={(e) => { e.stopPropagation(); UserLikeHandler(el.profile_id); }}>
                                      <svg className="w-[50px] h-[50px] p-[9px] rounded-full text-white bg-[rgba(152,14,255,255)]" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M26.4154 4.7698C27.4671 4.7698 28.5171 4.91813 29.5154 5.25313C35.6671 7.25313 37.8837 14.0031 36.0321 19.9031C34.9821 22.9181 33.2654 25.6698 31.0171 27.9181C27.7987 31.0348 24.2671 33.8015 20.4654 36.1848L20.0487 36.4365L19.6154 36.1681C15.8004 33.8015 12.2487 31.0348 9.00039 27.9015C6.76706 25.6531 5.04873 22.9181 3.98206 19.9031C2.09873 14.0031 4.31539 7.25313 10.5337 5.21813C11.0171 5.05146 11.5154 4.9348 12.0154 4.8698H12.2154C12.6837 4.80146 13.1487 4.7698 13.6154 4.7698H13.7987C14.8487 4.80146 15.8654 4.9848 16.8504 5.3198H16.9487C17.0154 5.35146 17.0654 5.38646 17.0987 5.41813C17.4671 5.53646 17.8154 5.6698 18.1487 5.85313L18.7821 6.13646C18.9351 6.21808 19.1069 6.3428 19.2553 6.45058C19.3494 6.51887 19.4341 6.58037 19.4987 6.6198C19.5259 6.63585 19.5536 6.65198 19.5814 6.66825C19.7243 6.75167 19.8732 6.83857 19.9987 6.9348C21.8504 5.5198 24.0987 4.75313 26.4154 4.7698ZM30.8487 16.7698C31.5321 16.7515 32.1154 16.2031 32.1654 15.5015V15.3031C32.2154 12.9681 30.8004 10.8531 28.6487 10.0365C27.9654 9.80146 27.2154 10.1698 26.9654 10.8698C26.7321 11.5698 27.0987 12.3365 27.7987 12.5848C28.8671 12.9848 29.5821 14.0365 29.5821 15.2015V15.2531C29.5504 15.6348 29.6654 16.0031 29.8987 16.2865C30.1321 16.5698 30.4821 16.7348 30.8487 16.7698Z" fill="#FFFFFF" />
                                        <defs>
                                          <linearGradient id="paint0_linear_1606_27736" x1="36.6657" y1="36.4365" x2="-2.66883" y2="24.4315" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="#FF0025" />
                                            <stop offset="1" stop-color="#FF6B81" />
                                          </linearGradient>
                                        </defs>
                                      </svg>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>)
                    })}
                  </div>
                  : <div className="p-[16px] bg-white rounded-[0.56rem] flex justify-center items-center min-h-[480px]  ">
                    <h2 className="m-0 text-center">{t('No Any User Like You...')}</h2>
                  </div>
              )}
              {showPage === "Favorite" && (
                favourite.length > 0
                  ? <div className="grid grid-cols-4 grid-transition grid-responsive card p-[16px] card-rounded">
                    {favourite?.map((el, i) => {
                      return (
                        <div key={i} onClick={() => DetailsHandler(el.profile_id, el.profile_name)} className="custom-card cursor-pointer card-rounded-1 duration-[1s] ease-in z-[111]" >
                          <div className="position-relative">
                            <div className="card-title">
                              <div className="card-img relative HEIGHT">
                                <div className=" flex justify-center w-[100%] absolute">
                                  <h6 className="m-0 text-white font-[400] text-[14px] bg-[rgba(152,14,255,255)] p-2 rounded-b-[15px]">{el.match_ratio.toFixed(0)}% Match</h6>
                                </div>
                                <img src={imageBaseURL + el.profile_images[0]} alt="img" className="img-fluid rounded-[3rem] BEFORE border-[5px] border-[rgba(152,14,255,255)]" />
                              </div>
                              <div className="card-content absolute bottom-[2rem] px-[15px] w-full">
                                <div className="profile-info">
                                  <div className="KM2 mb-2">
                                    <h6 className="m-0 ml-1 flex items-center gap-1"><HiOutlineLocationMarker /> {el.profile_distance}</h6>
                                  </div>
                                  <div className="text-center">
                                    <h6 className="font-semibold mb-1 text-white">
                                      {el.profile_name}, {el.profile_age}
                                    </h6>
                                  </div>
                                  <p className="bio mb-1 text-[18px] text-center mt-[5px] text-white overflow-ellipsis overflow-hidden whitespace-nowrap">
                                    {el.profile_bio !== "undefined" ? el.profile_bio : ""}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>)
                    })}
                  </div>
                  : <div className="p-[16px] bg-white rounded-[0.56rem] flex justify-center items-center min-h-[480px]  ">
                    <h2 className="m-0 text-center">{t('No Any Favourite Profiles...')}</h2>
                  </div>
              )}
              {showPage === "Passed" && (
                passed.length > 0
                  ? <div className="grid grid-cols-4 grid-transition grid-responsive   card p-[16px] card-rounded">
                    {passed?.map((el, i) => {
                      return (
                        <div key={i} onClick={() => DetailsHandler(el.profile_id, el.profile_name)} className="custom-card cursor-pointer card-rounded-1 duration-[1s] ease-in z-[111]" >
                          <div className="position-relative">
                            <div className="card-title">
                              <div className="card-img relative HEIGHT">
                                <div className=" flex justify-center w-[100%] absolute">
                                  <h6 className="m-0 text-white font-[400] text-[14px] bg-[rgba(152,14,255,255)] p-2 rounded-b-[15px]">{el.match_ratio.toFixed(0)}% Match</h6>
                                </div>
                                <img src={imageBaseURL + el.profile_images[0]} alt="img" className="img-fluid rounded-[3rem] BEFORE border-[5px] border-[rgba(152,14,255,255)]" />
                              </div>
                              <div className="card-content absolute bottom-[2rem] px-[15px] w-full">
                                <div className="profile-info">
                                  <div className="KM2 mb-2">
                                    <h6 className="m-0 ml-1 flex items-center gap-1"><HiOutlineLocationMarker /> {el.profile_distance}</h6>
                                  </div>
                                  <div className="text-center">
                                    <h6 className="font-semibold mb-1 text-white">
                                      {el.profile_name}, {el.profile_age}
                                    </h6>
                                  </div>
                                  <p className="bio mb-1 text-[18px] text-center mt-[5px] text-white overflow-ellipsis overflow-hidden whitespace-nowrap">
                                    {el.profile_bio !== "undefined" ? el.profile_bio : ""}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>)
                    })}
                  </div>
                  : <div className="p-[16px] h-[480px] bg-white rounded-[0.56rem] flex justify-center items-center">
                    <h2 className="m-0 text-center">{t('No Any Passed Profiles...')}</h2>
                  </div>
              )}
              {loading && <div className="flex justify-center w-[100%] bg-[#fff] rounded-[0.56rem] -mt-[30px]">
                <LodingLottie ClassCss={"w-[10%] max-_430_:w-[30%] max-_1145_:w-[20%] max-_1200_:w-[20%] max-_1300_:w-[15%]"} />
              </div>}
            </div>
          </div>
        </div>
      </div>

      {isShow && (
        <div className="w-[100%] h-[100vh] ms-[8rem] max-_991_:ms-0 bg-white fixed flex items-center justify-center top-0 left-0 right-0 bottom-0 z-[555]">
          <LodingLottie ClassCss={"w-[20%] max-_430_:w-[100%] max-_770_:w-[50%] max-_1030_:w-[40%] max-_1145_:w-[30%] max-_1200_:w-[30%] max-_1300_:w-[30%]"} />
        </div>
      )}

    </div>
  );
};

export default Favorites;
/* jshint ignore:end */